export default __webpack_public_path__ + "static/media/EMprint Bold.ba2db909.svg";